import { render, staticRenderFns } from "./ReviewSummary.vue?vue&type=template&id=840c0472&scoped=true&"
import script from "./ReviewSummary.vue?vue&type=script&lang=js&"
export * from "./ReviewSummary.vue?vue&type=script&lang=js&"
import style0 from "./ReviewSummary.vue?vue&type=style&index=0&id=840c0472&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "840c0472",
  null
  
)

export default component.exports